import Vue from 'vue';
import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'companyConfigManager';
root.data = {
  titleName: '',
  
  imageUrl: '',

	companyData: {
		data: {
			name: '',
			systemName: '',
			recordInfo: '',
			companyImageVo: {},
		},
		urlData: {
			data: [],
			showUplaodInterface: false,
			//总页数
			total: 1,
			//当前页数
			thisPage: 1,
			//每页多少行
			limit: 1,

			//选择了某张图片
			choosePicCache: {
				chooseIndex: -1,
			}
		},
	}
};
root.methods = {
	//获取公司信息
	getCompanyInfo: function() {
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').companyInfo)
			.openLoad().startGet().then((res) => {
        that.companyData.data = res.body.data;
        this.imageUrl = res.body.data.companyImageVo.imageUrl
			});
	},

	//更新公司配置
	upateCompanyInfo: function() {
		if (this.companyData.data.name === '') {
			this.$message({
				message: '请输入名称',
				type: 'error'
			});
			return;
		}
		if (this.companyData.data.systemName === '') {
			this.$message({
				message: '请输入系统名称',
				type: 'error'
			});
			return;
		}
		const that = this;
		let formdata = new FormData();
		formdata.append("name", this.companyData.data.name);
		formdata.append("systemName", this.companyData.data.systemName);
		formdata.append("recordInfo", this.companyData.data.recordInfo);
		formdata.append("id", this.companyData.data.id);
		formdata.append("mapUrl", this.companyData.data.mapUrl);
		formdata.append("imageId", this.companyData.data.imageId);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').companyUpdate)
			.openLoad().startPost(formdata).then((res) => {
        this.$message.success('更新成功')
        that.getCompanyInfo();
			});
  },
  handleAvatarSuccess(res, file) {
    console.log(res)
    this.imageUrl = file.response.data.imageUrl;
    this.companyData.data.imageId = file.response.data.id
  },


	// convertImage: function() {
	// 	if (this.companyData.data.companyImageVo.imageUrl === undefined ||
	// 		this.companyData.data.companyImageVo.imageUrl === '') {
	// 		return require('../../../../assets/img/companyConfigImgSet.png');
	// 	}
	// 	return this.companyData.data.companyImageVo.imageUrl;
	// },

	// //选择图片
	// selectImage: function(e) {
	// 	const select = document.getElementById("uploadImageInput");
	// 	select.click();
	// },

	// //上传图片
	// uploadImage: function(e) {
	// 	const that = this;
	// 	const file = e.target.files[0];
	// 	let formdata = new FormData();
	// 	formdata.append("file", file);
	// 	this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').uploadImage)
	// 		.openLoad().startPost(formdata).then((res) => {
	// 			that.selectImageSetHead(that.companyData.urlData.thisPage);
	// 		});
	// },

	// //获取图片列表
	// selectImageSetHead: function(page) {
	// 	const that = this;
	// 	let formdata = new FormData();
	// 	formdata.append("curPage", page);
	// 	formdata.append("limit", this.companyData.urlData.limit);
	// 	this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').geImageAll)
	// 		.openLoad().startPost(formdata).then((res) => {
	// 			that.companyData.urlData.data = res.body.data;
	// 			that.companyData.urlData.total = res.body.cum;
	// 			that.companyData.urlData.thisPage = res.body.page;
	// 			that.companyData.urlData.showUplaodInterface = true;
	// 		});
	// },

	// //删除图片
	// delImageData: function(item) {
	// 	const that = this;
	// 	this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').delImage+item.id)
	// 		.openLoad().startDel().then((res) => {
	// 			that.selectImageSetHead(that.companyData.urlData.thisPage);
	// 		});
	// },

	// //查看大图
	// lookImage: function(item) {

	// },

	// //在图片列表点击图片
	// selectImageInHead: function(index) {
	// 	this.companyData.urlData.choosePicCache.chooseIndex = index;
	// },

	// //取消选择图片
	// chooseHeadSetCancel: function() {
	// 	this.companyData.urlData = {
	// 		data: [],
	// 		showUplaodInterface: false,
	// 		total: 1,
	// 		thisPage: 1,
	// 		limit: 1,
	// 		choosePicCache: {
	// 			chooseIndex: -1,
	// 		}
	// 	}
	// },

	// //确认选择图片
	// chooseHeadSetOk: function() {
	// 	const item = this.companyData.urlData.data[this.companyData.urlData.choosePicCache.chooseIndex];
	// 	this.chooseHeadSetCancel();
	// 	this.companyData.data.companyImageVo = item;
	// }

};

root.mounted = function() {
	// let menuDatas = this.componentsMoudel.getData(this.$route.path);
	this.titleName = "公司配置";
	this.getCompanyInfo();
};

FactoryComponents.initComponent(root);
